module.exports = __webpack_public_path__ + "static/memory-eb440b8f97d924bbc71b99ca530b7d47.png";